(function () {
  var desktop = window.matchMedia('(min-width: 990px)');

  Array.prototype.forEach.call(document.querySelectorAll('.cdi-dv-eng__grid'), function (grid) {
    if (grid.dataset.cdiInit) return;
    grid.dataset.cdiInit = '1';

    var dots = Array.prototype.slice.call(grid.querySelectorAll('[data-cdi-dv-eng-dot]'));
    if (!dots.length) return;
    var open = null;

    function noteFor(dot) {
      return document.getElementById(dot.getAttribute('aria-controls'));
    }

    function close() {
      if (!open) return;
      open.classList.remove('is-active');
      open.setAttribute('aria-expanded', 'false');
      var note = noteFor(open);
      if (note) note.classList.remove('is-open');
      open = null;
    }

    function show(dot) {
      close();
      var note = noteFor(dot);
      if (!note) return;
      note.classList.add('is-open');
      dot.classList.add('is-active');
      dot.setAttribute('aria-expanded', 'true');
      open = dot;
    }

    function sync() {
      if (desktop.matches) {
        dots.forEach(function (dot) { dot.setAttribute('aria-expanded', dot === open ? 'true' : 'false'); });
      } else {
        close();
        dots.forEach(function (dot) { dot.removeAttribute('aria-expanded'); });
      }
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function (e) {
        if (!desktop.matches) return;
        e.preventDefault();
        if (open === dot) close();
        else show(dot);
      });
    });

    document.addEventListener('click', function (e) {
      if (!open || !desktop.matches) return;
      if (e.target.closest('[data-cdi-dv-eng-dot]') || e.target.closest('.cdi-dv-eng__note.is-open')) return;
      close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !open) return;
      var dot = open;
      close();
      dot.focus();
    });

    if (desktop.addEventListener) desktop.addEventListener('change', sync);
    sync();
  });
})();
